import {
  Component,
  OnInit,
  Input,
  ViewChild,
  SimpleChanges,
  Output,
  EventEmitter
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { from } from "rxjs";

@Component({
  selector: "app-data-listing",
  templateUrl: "./data-listing.component.html",
  styleUrls: ["./data-listing.component.css"]
})
export class DataListingComponent implements OnInit {
  @Input("data") data: any = [];
  @Input("columns") columns: any[] = [];
  @Input("subtitle") subtitle: string = "Tous les éléments";
  @Input("baseLink") baseLink: string = "";
  @Output("selected") selected = new EventEmitter<any>();
  @Output("reordered") reordered = new EventEmitter<any>();

  editing = {};
  rows = [];
  temp = [];

  loadingIndicator = true;
  reorderable = true;

  dragulaName = "";

  @ViewChild(DataListingComponent) table: DataListingComponent;
  constructor(private router: Router, private route: ActivatedRoute) {
    //console.log("DataListingComponent constructor");
    this.dragulaName = this.makeid(5);
  }

  makeid(length) {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  ngOnInit() {}

  doInit() {
    //console.log("received : ", this.data);
    this.rows = this.data;
    this.temp = [...this.data];
    setTimeout(() => {
      this.loadingIndicator = false;
    }, 1500);
  }

  ngAfterViewInit() {
    console.log(">DataListingComponent ngAfterViewInit");
    this.doInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    if (changes["data"]) {
      this.doInit();
    }
  }

  updateFilter(event) {
    console.log("updateFilter");
    const val = event.target.value.toLowerCase();

    // filter our data
    const localthis = this;

    const temp = this.temp.filter(function(d) {
      for (let column of localthis.columns) {
        var value = _.get(d, column.prop);
        if (typeof value == "number" && !isNaN(Number(val))) {
          if (_.get(d, column.prop) == Number(val)) return true;
        }
        if (typeof value == "string") {
          if (
            _.get(d, column.prop)
              .toLowerCase()
              .indexOf(val) !== -1 ||
            !val
          )
            return true;
        }
      }
      return false;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    //this.table = this.data;
  }

  /* onActivate(event) {
    console.dir(event);
  } */
  onSelected($event) {
    if ($event.type == "click" || $event.type == "dblclick") {
    } else return;
    this.selected.emit($event.row);
    //console.dir($event.row);

    this.router.navigate(["./" + this.baseLink + "/" + $event.row.id], {
      relativeTo: this.route
    });
  }

  renderTable = true;

  onDrop(range) {
    //console.log("onDrop", event);
    const { from_index, to_index, newArray, elementsorder } = range;

    //reorder elements locally
    for (let i = from_index; i <= to_index; i++) {
      this.rows[i] = _.cloneDeep(newArray[i]);
    }

    //notify parent that order has changed
    this.reordered.emit(elementsorder);
  }

  onDrag(event) {
    //console.log("DRAG event::", event);
  }
}
